import React, { useCallback } from 'react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { LabeledSelect, ValueType } from 'components/spaceKit';

type ActionSelectGroupProps = {
    label?: string;
    error?: string;
    required?: boolean;
    value: string; // key on object to modify
    option: {}; // object to modify
    inheritClear?: boolean;
    isClearable?: boolean;
    options: Array<{ [key: string]: any }>;
    defaultValue?: ValueType;
    isSearchable?: boolean;
    isMulti?: boolean;
    isDisabled?: boolean;
    name?: string;
    isLoading?: boolean;
    placeholder?: string;
    valueKey?: string;
    labelKey?: string;
    clearValue?: { [key: string]: any };
    replaceOption?: boolean;
};

const ActionSelectGroup: React.FC<ActionSelectGroupProps> = ({
    option,
    value,
    replaceOption = false,
    valueKey = 'value',
    ...group
}) => {
    const currentValue = group.options.find(groupOption => {
        const valueToCheck = replaceOption ? option[value]?.[valueKey] : option[value];
        return groupOption[valueKey] === valueToCheck;
    });

    const handleChange = useCallback(
        (selectedOption: { name: string; value: string }) => {
            runInAction(() => {
                option[value] = replaceOption ? selectedOption : selectedOption[valueKey];
            });
        },
        [option, replaceOption, value, valueKey]
    );

    return (
        <LabeledSelect
            {...group}
            valueKey={valueKey}
            value={currentValue}
            onChange={handleChange}
        />
    );
};

ActionSelectGroup.displayName = 'ActionSelectGroup';
export default observer(ActionSelectGroup);
